module.exports = __webpack_public_path__ + "img/比江岛慎.c50ad43e.png";